angular.module('TInv.alert', [
    'ui.bootstrap',
]).factory('alert', function ($log, $rootScope, $uibModal, revision) {
    function alertModal(str, title) {
        return $uibModal.open({
            templateUrl: 'template/alert.html?rev=' + revision,
            scope: $rootScope.$new(true), // create isolated scope
            controller: function ($scope) {
                $scope.title = title;
                if (typeof str == 'string')
                    $scope.text = str;
                else if (typeof str == 'object' && 'message' in str)
                    $scope.text = str.message;
                else
                    $scope.text = String(str);
            }
        });
    }
    return {
        error: function (str) {
            $log.error(str);
            return alertModal(str, 'Error');
        },
        warning: function (str) {
            $log.info(str);
            return alertModal(str, 'Warning');
        },
    };
});
